import { computed, reactive, h, defineComponent } from '@vue/composition-api';
import { useContext } from '@berlin-front/common/composables/context';
import { ApiCacheContext } from '@services/ApiCacheContext';
import { broadcast } from '@/broadcast';
import { windowOpenNewTab } from '@berlin-front/common/utils';
import AtoneNgDetailVue from '@views/fail/auth-ng/detail-link/AtoneNgDetail.vue';
import AuthFailDetailAppDownload from '@views/fail/auth-ng/detail-link/AuthFailDetailAppDownload.vue';
import AuthFailDetailReason from '@views/fail/auth-ng/detail-link/AuthFailDetailReason.vue';
import AuthFailDetailMyPage from '@views/fail/auth-ng/detail-link/AuthFailDetailMyPage.vue';
import AuthFailDetailNpMyPage from '@views/fail/auth-ng/detail-link/AuthFailDetailNpMyPage.vue';
import { AuthNgFailContextType } from './composable';

const atoneAuthNgFail: AuthNgFailContextType = {
  useAuthNgFail: () => {
    const { atoneCapturePostResult, atoneSplitCapturePostResult, atoneReauthorizePutResult } =
      useContext(ApiCacheContext);

    const authorizationResult = computed(
      () => atoneReauthorizePutResult.value || atoneCapturePostResult.value || atoneSplitCapturePostResult.value,
    );

    const authorizationResultNgMessage = computed(() => authorizationResult.value?.authorizationResultNgMessage ?? []);

    const showAppDownloadLink = computed(() => authorizationResult.value?.appDownloadFlg ?? false);
    const showNpMyPageLink = computed(
      () =>
        atoneReauthorizePutResult.value?.atobaraiMemberPageFlg ??
        atoneCapturePostResult.value?.atobaraiMemberPageFlg ??
        false,
    );
    // TODO: split/capture に atobaraiMemberPageFlg が実装されたらこちらに変更する
    // const showNpMyPageLink = computed(() => authorizationResult.value?.atobaraiMemberPageFlg ?? false);
    const showMyPageLink = computed(() => false);
    const showAuthFailDetailReason = computed(() => true);

    const DetailComponent = computed(() =>
      defineComponent({
        render: () =>
          h(AtoneNgDetailVue, {}, [
            showAuthFailDetailReason.value ? h(AuthFailDetailReason) : undefined,
            showNpMyPageLink.value ? h(AuthFailDetailNpMyPage) : undefined,
            showMyPageLink.value ? h(AuthFailDetailMyPage) : undefined,
            showAppDownloadLink.value ? h(AuthFailDetailAppDownload) : undefined,
          ]),
      }),
    );

    const onCancel = () => {
      broadcast.send({
        type: 'MODAL_CONTROL_FAILED',
        payload: {},
      });
    };

    const onInquiry = () => {
      windowOpenNewTab(process.env.VUE_APP_ATONE_FAQ_URL);
    };

    return reactive({
      // 表示項目
      ngReasons: authorizationResultNgMessage,

      detailComponent: DetailComponent,

      // 関数,
      onCancel,
      onInquiry,
    });
  },
};

export default atoneAuthNgFail;
